import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isEmpty } from 'lodash';
import { CommonService } from 'src/app/providers/common.service';

@Component({
  selector: 'app-deactivated-merchant-listv2',
  templateUrl: './deactivated-merchant-listv2.component.html',
  styleUrls: ['./deactivated-merchant-listv2.component.scss']
})
export class DeactivatedMerchantListv2Component implements OnInit {

  constructor(public modal: NgbActiveModal, private ngbModal:NgbModal,private commonService: CommonService) { }
  deactivatedMerchantList:any;
  @Input() deactivatedMerchant :any;
  buttonLoader: any= false;

  ngOnInit(): void {
    // console.log("this.deactivatedMerchant", this.deactivatedMerchant)
    for (let obj of this.deactivatedMerchant) {
      for (let key in obj) {
        obj["st"]
        if (key == "merchant_to_stores.dba") {
          obj["storeDba"] = obj[key];
        }
        obj["merchantName"] = obj["firstName"] + " " + obj["lastName"];
        obj["storeName"] = obj["merchant_to_stores.firstName"] + " " + obj["merchant_to_stores.lastName"];
        if (key == "merchant_to_stores.store_to_tpns.tpn") {
          obj["tpn"] = obj[key];
        }
        if (key == "merchant_to_stores.store_to_tpns.merchantInfo") {
          obj["merchantInfo"] = JSON.parse(obj[key]);
          obj["tpnDba"] = !isEmpty(obj["merchantInfo"])? obj["merchantInfo"]["dba"] : '';
        }
      }
    }
    this.deactivatedMerchantList = this.deactivatedMerchant;
  }

  downloadData(){
    this.buttonLoader = true;
    let fileName = "Deactivated_Merchants_Report.xlsx";
    let worksheetData = {
      "worksheet" : [
        {
          "name": 'Deactivated Merchants',
          "columns":  [
            { header: "ISO", key: "createdBy", width: 25 },
            { header: "Merchant DBA", key: "dba", width: 25 },
            { header: "Merchant Name", key: "merchantName", width: 25 },
            { header: "Store DBA", key: "tpnDba", width: 25 },
            { header: "Store Name", key: "storeName", width: 25 },
            { header: "TPN", key: "tpn", width: 20 },
            { header: "Created On", key: "formattedCreatedAt", width: 30},
            { header: "Deactivated On", key: "formattedDeactivatedOn", width: 30},
            { header: "Last Transaction Date", key: "formattedLastTxDate", width: 30},
          ],
          "rows": this.deactivatedMerchant,
          "isRow": 0,
          frozen:true,
        }
      ],
      "fileName": fileName
    };

    this.commonService.downloadAsExcel(worksheetData).then(res => {
      // this.modalReference.close();
      this.buttonLoader = false;
    });
  }
}
